export default __webpack_public_path__ + "static/media/LAS0920.34I-41362_-24659_0.6c5262d8.jpg";